import { DimensionValueByType } from '../../shared-types';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export function trackAvailableDimensionUiTypes(rootElement: HTMLElement): void {
    const dimensionLists = rootElement.querySelectorAll('[data-dimension-type]');
    const availableDimensionTypes = new Array<string>();
    dimensionLists.forEach(dimensionList => {
        if (!dimensionList.parentElement) return;
        if (window.getComputedStyle(dimensionList.parentElement).display === 'none') return;
        const dimensionType = dimensionList.getAttribute('data-dimension-type');
        if (!dimensionType) return;
        availableDimensionTypes.push(dimensionType);
    });
    trackView({ product_DimensionTypesAvailable: availableDimensionTypes });
}

export function trackInvalidDimensions(loadedDimensionsState: DimensionValueByType[]): void {
    const invalidDimensions = loadedDimensionsState.filter(dimensionState => dimensionState.value === undefined);
    if (invalidDimensions.length) {
        trackEvent({
            product_Fault: [invalidDimensions.map(invalidDimensions => invalidDimensions.type).join(',')],
        });
    }
}
